"use client";

import clsx from "clsx";
import type { ComponentProps, ReactNode } from "react";

import s from "./detail-info-list.module.scss";

export type DetailInfoListProps = ComponentProps<"div"> & {
  className?: string;
  children: ReactNode;
};

export const DetailInfoList = (props: DetailInfoListProps) => {
  const { className, children, ...rest } = props;

  return (
    <div className={clsx(s.root, className)} {...rest}>
      {children}
    </div>
  );
};

DetailInfoList.displayName = "DetailInfoList";
